import { request, type ApiResponse } from "../client";
import type {
  AccountNode,
  AllocateAccountIn,
  AllocateSiteIn,
  AllocationOut,
  GateStatusOut,
  PreviewOut,
} from "../types/allocation";

export interface PreviewParams {
  kind: "account" | "site";
  market_pool?: string;
  site_slug?: string;
}

export const allocations = {
  gate: (): Promise<ApiResponse<GateStatusOut>> =>
    request<GateStatusOut>("GET", "/api/v1/allocations/gate"),

  ledger: (accountSlug?: string): Promise<ApiResponse<AccountNode[]>> =>
    request<AccountNode[]>(
      "GET",
      accountSlug
        ? `/api/v1/allocations?account_slug=${encodeURIComponent(accountSlug)}`
        : "/api/v1/allocations",
    ),

  preview: (params: PreviewParams): Promise<ApiResponse<PreviewOut>> => {
    const q = new URLSearchParams({ kind: params.kind });
    if (params.market_pool) q.set("market_pool", params.market_pool);
    if (params.site_slug) q.set("site_slug", params.site_slug);
    return request<PreviewOut>("GET", `/api/v1/allocations/preview?${q.toString()}`);
  },

  allocateAccount: (body: AllocateAccountIn): Promise<ApiResponse<AllocationOut>> =>
    request<AllocationOut>("POST", "/api/v1/allocations/accounts", body),

  allocateSite: (body: AllocateSiteIn): Promise<ApiResponse<AllocationOut>> =>
    request<AllocationOut>("POST", "/api/v1/allocations/sites", body),
};
